var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C11.5523 0 12 0.447715 12 1V1.66669H12.6667C13.9553 1.66669 15 2.71136 15 4.00002V6.66669V13.3334C15 14.622 13.9553 15.6667 12.6667 15.6667H3.33333C2.04467 15.6667 1 14.622 1 13.3334V6.66669V4.00002C1 2.71136 2.04467 1.66669 3.33333 1.66669H4V1C4 0.447715 4.44772 0 5 0C5.55228 0 6 0.447715 6 1V1.66669H10V1C10 0.447715 10.4477 0 11 0ZM3 4.00002C3 3.81593 3.14924 3.66669 3.33333 3.66669H12.6667C12.8508 3.66669 13 3.81593 13 4.00002V5.66669H3V4.00002ZM13 7.66669V13.3334C13 13.5174 12.8508 13.6667 12.6667 13.6667H3.33333C3.14924 13.6667 3 13.5174 3 13.3334V7.66669H13Z",
    fill: "#7A23FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.d68c4e38d6e84c6d56607c20f998e1e8.svg";
export { ForwardRef as ReactComponent };